import { ChevronRight } from 'lucide-react';
import { CalendarPumpkinIcon } from '../icons/SpookyIcons';

type Props = {
  onOpenCalendar: () => void;
};

export const CompactCalendar = ({ onOpenCalendar }: Props) => {
  const today = new Date();
  const monthLabel = new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(today);
  const dayLabel = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(today);

  return (
    <article className="compact-calendar dashboard-card">
      <div className="card-heading-row">
        <span className="card-heading-icon" aria-hidden="true"><CalendarPumpkinIcon size={24} /></span>
        <div><p className="eyebrow">Current date</p><h2>{monthLabel}</h2></div>
      </div>
      <div className="today-lockup">
        <strong>{today.getDate()}</strong>
        <span><b>{dayLabel}</b><small>Your calendar is ready for its first event.</small></span>
      </div>
      <button type="button" className="text-button" onClick={onOpenCalendar}>
        Open full calendar <ChevronRight size={17} aria-hidden="true" />
      </button>
    </article>
  );
};
